import moment from 'moment';

// Returns undefined when the series is empty or every entry's `key` is null
// (e.g. umbrella / Keiralis funds that expose no share history yet).
export function getLatestNonNullValue<T, K extends keyof T>(arr: T[], key: K): T | undefined {
	let lastValidIndex = arr.length - 1;

	while (lastValidIndex >= 0 && arr[lastValidIndex][key] === null) {
		lastValidIndex--;
	}

	return lastValidIndex >= 0 ? arr[lastValidIndex] : undefined;
}

// Formatted display date of the most recent entry whose `key` is non-null, or
// '-' when the series is empty / has no non-null value. Guards the crash seen
// on umbrella / Keiralis funds whose capital series carries no share values.
export function formatLatestNonNullValueDate<T extends { date?: moment.MomentInput }, K extends keyof T>(
	data: T[] | undefined,
	key: K,
	format = 'DD/MM/YYYY',
): string {
	const latest = data ? getLatestNonNullValue(data, key) : undefined;
	return latest ? moment(latest.date).format(format) : '-';
}
